module.exports = __webpack_public_path__ + "img/45Trump.be5434c4.png";